/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DevisConsultationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Suivi des devis envoyes en signature
     * Chaque devis de l'entreprise ayant au moins un lien de signature, avec le client, le commercial, les statistiques de liens (`total`, `signed`, `pending`), la date du dernier lien envoye et les consultations du client (quand il a ouvert le devis). Tableau vide si aucun lien n'a ete cree.
     * @returns any
     * @throws ApiError
     */
    public devisConsultationIndex(): CancelablePromise<(string | Array<string>)> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/devis_consulation',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Enregistrer la consultation d'un devis
     * Appele quand le client ouvre un devis dans son espace : enregistre la consultation (une seule par devis tant qu'il n'est pas signe) et en informe l'entreprise. 201 avec la consultation ; 200 `{ message }` si le devis est deja signe.
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public devisConsultationCreate(
        requestBody: {
            id_devis: number;
        },
    ): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/devis_consulation',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Detail du suivi d'un devis
     * Le devis et son client, l'historique des consultations par le client (`date`) et tous les liens de signature (`id`, `status`, `url`, `created_at`, signataire une fois signe), du plus recent au plus ancien.
     * @param idDevis
     * @returns any
     * @throws ApiError
     */
    public devisConsultationShow(
        idDevis: string,
    ): CancelablePromise<{
        devis: {
            IDDEVIS: string;
            NUMERO_DEVIS: string;
            DEVIS_SIGNE: string;
            DATE_SIGNATURE: string;
            DATE_TRANSMISSION: string;
            DATE_CREATION: string;
            MONTANT_TTC: string;
            CLIENT: {
                IDCLIENT: string;
                NOM_COMPLET: string;
                EMAIL: string;
                PORTABLE: string;
            };
        };
        consultations: string;
        signature_links: string;
        timeline: string;
        stats: {
            total_consultations: string;
            total_links_created: string;
            has_active_link: string;
        };
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/devis_consulation/{id_devis}',
            path: {
                'id_devis': idDevis,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
}
